// SsoCallback - handles redirect back from API after SAML authentication.
// Reads tokens from URL params, stores in localStorage, and navigates to dashboard.
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setLocalStorage } from "../helpers/common";
import { USER_INFO_KEY } from "../constants/common";

const SsoCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get("token");
    const refresh = searchParams.get("refresh");
    const userId = searchParams.get("userId");
    const onboarding = searchParams.get("onboarding");

    if (!token || !userId) {
      setError("Missing authentication data. Please try signing in again.");
      return;
    }

    // Store session in the same format as updateUserDetailsToStorage
    const userDetails = {
      token: {
        accessToken: token,
        refreshToken: refresh || "",
        providerLogin: "saml",
      },
      userInfo: {
        userId: userId,
        userType: 2, // Agent
      },
    };
    setLocalStorage(USER_INFO_KEY, userDetails);

    // Strip tokens from URL immediately for security
    window.history.replaceState({}, document.title, "/sso-callback");

    // Navigate to the appropriate page
    if (onboarding === "true") {
      navigate("/agent-profile", { replace: true });
    } else {
      navigate("/agent-dashboard", { replace: true });
    }
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        fontFamily: "'Inter', sans-serif",
      }}>
        <div style={{ textAlign: "center", maxWidth: 400 }}>
          <h2 style={{ color: "#dc2626", marginBottom: 16 }}>Sign-in Error</h2>
          <p style={{ color: "#6b7280" }}>{error}</p>
          <a href="/" style={{ color: "#2563eb", textDecoration: "underline" }}>
            Back to login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      fontFamily: "'Inter', sans-serif",
      color: "#6b7280",
    }}>
      Signing you in...
    </div>
  );
};

export default SsoCallback;
